import { PostExecutionResults } from 'api/Exec/types';
import { borderColorSplit } from 'app/consts/colors';

import { Flex, Form, Checkbox, Typography } from 'antd';
import React from 'react';

interface Props {
  results: PostExecutionResults | null;
  viewMode?: boolean;
}

const PostExecutionResultsForm: React.FC<Props> = ({ results, viewMode = false }) => {
  return (
    <Flex vertical style={{ border: `1px solid ${borderColorSplit}`, padding: 16, borderRadius: 8 }}>
      <Typography.Title level={5}>Post execution results</Typography.Title>

      <Form.Item name={[ 'postExecutionResults', 'ancestryPdfReport' ]} valuePropName="checked" style={{ marginBottom: 0 }}>
        <Checkbox disabled={viewMode || !results?.ancestryPdfReport}>PDF Ancestry report</Checkbox>
      </Form.Item>

      <Form.Item name={[ 'postExecutionResults', 'prsRuoCardioPdfReport' ]} valuePropName="checked" style={{ marginBottom: 0 }}>
        <Checkbox disabled={viewMode || !results?.prsRuoCardioPdfReport}>PDF PRS Research use cardiometabolic report</Checkbox>
      </Form.Item>

      <Form.Item name={[ 'postExecutionResults', 'prsRuoCancerPdfReport' ]} valuePropName="checked" style={{ marginBottom: 0 }}>
        <Checkbox disabled={viewMode || !results?.prsRuoCancerPdfReport}>PDF PRS Research use cancer report</Checkbox>
      </Form.Item>

      <Form.Item name={[ 'postExecutionResults', 'prsClinicalCardioPdfReport' ]} valuePropName="checked" style={{ marginBottom: 0 }}>
        <Checkbox disabled={viewMode || !results?.prsClinicalCardioPdfReport}>PDF PRS Clinical cardiometabolic report</Checkbox>
      </Form.Item>

      <Form.Item name={[ 'postExecutionResults', 'prsClinicalCancerPdfReport' ]} valuePropName="checked" style={{ marginBottom: 0 }}>
        <Checkbox disabled={viewMode || !results?.prsClinicalCancerPdfReport}>PDF PRS Clinical cancer report</Checkbox>
      </Form.Item>
    </Flex>
  );
};

export default PostExecutionResultsForm;
